export default function Footer() {
  return (
    <footer className="w-full bg-secondary-100 text-secondary-900">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-12 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-2">
            <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-label text-lg">
              看
            </span>
            <span className="font-label text-xl text-foreground-950">看料门专题</span>
          </div>
          <p className="mt-4 text-sm leading-relaxed max-w-sm">
            面向普通读者的事件信息梳理站。用一套通用框架，帮你看懂争议的来龙去脉、把散落的信息
            按节点与时间重新排清楚，并在纷杂说法中保持清醒。
          </p>
        </div>

        <nav className="md:col-span-3" aria-label="栏目导航">
          <h4 className="font-heading font-semibold text-foreground-950 mb-4">栏目导航</h4>
          <ul className="flex flex-col gap-2.5 text-sm">
            {[
              ["#intro", "事件导读"],
              ["#shimo", "来龙去脉"],
              ["#timeline", "时间线方法论"],
              ["#check", "核实方法"],
              ["#terms", "术语速查"],
              ["#faq", "常见问题"],
            ].map(([href, label]) => (
              <li key={href}>
                <a href={href} className="hover:text-primary-600 transition-colors whitespace-nowrap">
                  {label}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        <div className="md:col-span-4">
          <h4 className="font-heading font-semibold text-foreground-950 mb-4">阅读须知</h4>
          <p className="text-sm leading-relaxed">
            本专题内容仅为信息梳理与阅读参考，不代表对任何事件、机构或个人的最终定性。
            具体事实请以可溯源的一手信源与权威通报为准。
          </p>
          <a
            href="mailto:hello@kanliaomen-gate.com"
            className="mt-4 inline-flex items-center gap-2 text-sm text-primary-600 hover:text-primary-700"
          >
            <i className="ri-mail-line w-4 h-4 flex items-center justify-center" />
            hello@kanliaomen-gate.com
          </a>
        </div>
      </div>

      <div className="border-t border-secondary-200">
        <div className="max-w-6xl mx-auto px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-secondary-700">
          <p>© {new Date().getFullYear()} 看料门专题 · 信息梳理与阅读参考</p>
          <p className="flex items-center gap-2 whitespace-nowrap">
            <i className="ri-shield-check-line w-3.5 h-3.5 flex items-center justify-center" />
            理性阅读 · 以事实为准
          </p>
        </div>
      </div>
    </footer>
  );
}